import React from 'react';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { SystemIntro } from './components/SystemIntro';
import { Tomos } from './components/Tomos';
import { Bonuses } from './components/Bonuses';
import { WhyGlobal } from './components/WhyGlobal';
import { Offer } from './components/Offer';
import { Outcomes } from './components/Outcomes';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
type AppProps = {
  showUrgency?: boolean;
};
export function App({
  showUrgency = true
}: AppProps) {
  return <div className="w-full bg-sand font-sans text-ink" data-id="element-0" data-mp="2wip734ny5m5z">
      <Hero data-id="element-1" data-mp="28tmdcyg1g2v4" />
      <main data-id="element-2" data-mp="28te3zgj4jfoo">
        <PainPoints data-id="element-3" data-mp="28suw6sn6u7od" />
        <SystemIntro data-id="element-4" data-mp="28sbad0uf2z52" />
        <Tomos data-id="element-5" data-mp="23vkw8j26adma" />
        <Bonuses data-id="element-6" data-mp="23vulg4fe8gqx" />
        <WhyGlobal data-id="element-7" data-mp="23u9qidp62vsj" />
        <Offer showUrgency={showUrgency} data-id="element-8" data-mp="23v2r0wxj8p28" />
        <Outcomes data-id="element-9" data-mp="3ik7eyd5x05p2" />
        <Testimonials data-id="element-10" data-mp="3ikqz80j1f669" />
        <Guarantee data-id="element-11" data-mp="3ijfx0558q6h9" />
        <Faq data-id="element-12" data-mp="3ihv2ugmu8pjx" />
        <FinalCta showUrgency={showUrgency} data-id="element-13" data-mp="3ii4ppvcl6gle" />
      </main>
      <Footer data-id="element-14" data-mp="3mk83iqmq9x9u" />
    </div>;
}